/**
 * Shared time-formatting helpers.
 *
 * The backend stores times in 24-hour "HH:MM" (Central-anchored) form.
 * User-facing display should always be 12-hour with AM/PM per the
 * Feb-2026 UX pass ("Please make this update anywhere time formats
 * are used.").
 */

/**
 * Format a 24-hour "HH:MM" string as 12-hour with AM/PM.
 *
 *   "15:00" → "3:00 PM"
 *   "09:30" → "9:30 AM"
 *   "00:00" → "12:00 AM"
 *   ""      → ""
 *
 * Non-standard input is returned unchanged so we never crash on garbage.
 */
export function formatTime12(hhmm) {
  if (!hhmm) return "";
  const parts = String(hhmm).trim().split(":");
  if (parts.length < 2) return hhmm;
  const h = parseInt(parts[0], 10);
  const m = parts[1];
  if (Number.isNaN(h)) return hhmm;
  const period = h >= 12 ? "PM" : "AM";
  const twelve = h % 12 === 0 ? 12 : h % 12;
  return `${twelve}:${(m || "00").padStart(2, "0")} ${period}`;
}
